import React, { useRef, useEffect, useState } from "react";
import { Grid, Tooltip, IconButton } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import "./MenuBox.css";
import close from "../../../../asset/image/close.svg";

interface MenuOption {
  label: string;
  isSelected?: boolean;
}

interface MenuBoxProps {
    menuOpen: boolean;
    handleMenuClose: () => void;
    title?: string;
    showClose?: boolean;
    copyItem?: string;
    options?: MenuOption[];
    handleSelectOption?: (label: string) => void;
    top?: string;
    right?: string;
    addNewButton?: boolean;
    addNewName?: string;
    handleAddNewClick?: () => void;
}

const MenuBox = (props: MenuBoxProps) => {
    const {menuOpen, handleMenuClose, title, showClose=true, copyItem, options, handleSelectOption, top= "20px", right="44px", addNewButton, addNewName, handleAddNewClick} = props;
    const menuRef = useRef<HTMLDivElement>(null);

    const [copied, setCopied] = useState(false);
    const handleCopy = async (copyItem) => {
        if (copyItem) {
        await navigator.clipboard.writeText(copyItem.toString());
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as HTMLElement;
            if (menuRef.current?.contains(target)) return;
            handleMenuClose();
        };
        if (menuOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuOpen, handleMenuClose]);
    
    if (!menuOpen) return null;
    return(
        <div ref={menuRef} className="libraryConfigMenuFloating" style={{top:`${top}`, right: `${right}`}}>
            <div className="libraryConfigMenuDialogTitle">
                <Grid>
                    <span>{title}</span>
                </Grid>
                {showClose && <Grid className="cursorPointer">
                    <img src={close} title="Close" onClick={handleMenuClose} ></img>
                </Grid>}
            </div>
            <div className="menuContentPadding">
                {copyItem && <div className="libraryMenuItems">
                    <span className="configId">{copyItem}</span>
                    <Tooltip title={copied ? "Copied!" : "Copy"}>
                        <IconButton onClick={() => handleCopy(copyItem)} size="small">
                        <ContentCopyIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </div>}
                {options?.map((option, idx) => (
                    <div
                        key={idx}
                        className={`libraryMenuOptions ${
                        option.isSelected ? "selectedConfig" : ""
                        }`}
                        onClick={() => handleSelectOption?.(option.label)}
                    >
                        <span>{option.label}</span>
                    </div>
                ))}
                {addNewButton && <div
                    className="addNewButton"
                    onClick={handleAddNewClick}
                >
                    <span>{addNewName?? "+"}</span>
                </div>}
            </div>
        </div>
    )
}

export default MenuBox;